<template>
  <div>
    <button @click="onPrevious" :disabled="!previous">◀</button>
    <button @click="onNext" :disabled="!next">▶</button>
  </div>
</template>
<script>
export default {
  name: 'hippolyte.paginate.cursor',
  props: {
    previous: String,
    next: String
  },
  data () {
    return {}
  },
  methods: {
    onPrevious () {
      if (this.previous) {
        this.select(this.previous)
      }
    },
    onNext () {
      if (this.next) {
        this.select(this.next)
      }
    },
    select (value) {
      this.$emit('input', value)
    }
  }
}
</script>
<style lang="stylus" scoped>
@require '~/colors.styl'
button
  background white
  border none
  color black
  border-radius 2em
  line-height 1em
  margin 0.2em 0
  padding 0.4em 1.5em
  font-size 0.9em
  cursor pointer
  text-decoration none
  &::first-letter
    text-transform capitalize
  &:focus, &:hover
    outline none
  &.invert
    color white
    border 1px white solid
  &:disabled
    color #ccc
    cursor default
</style>
